import SelectionState from "state/selections/SelectionState";
import {
  selectDefinitions,
  selectFetchingAltDateData,
  selectFetchingData,
} from "./selectors";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteColumn } from "state/grid/actions";
import SummaryType from "state/selections/Constants/SummaryType";

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsoluteData = useSelector(
    selectFetchingData(SummaryType.ABSOLUTE)
  );
  const fetchingRelativeData = useSelector(
    selectFetchingData(SummaryType.RELATIVE)
  );
  const fetchingAbsAltDateData = useSelector(
    selectFetchingAltDateData(SummaryType.ABSOLUTE)
  );
  const fetchingRelAltDateData = useSelector(
    selectFetchingAltDateData(SummaryType.RELATIVE)
  );
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.map((definition) => {
      const { summary, factribFactor, factribPeriod, factribAsOfDate } =
        definition;
      let colId = `factor attrib - ${factribFactor}, ${factribPeriod}, ${summary}`;
      let headerName = `Factor Attrib - ${factribFactor}, ${factribPeriod}, ${summary}`;
      let loading = false;
      if (factribAsOfDate) {
        colId += `, ${factribAsOfDate}`;
        headerName += `, As of: ${factribAsOfDate}`;
        if (
          (summary === SummaryType.ABSOLUTE &&
            fetchingAbsAltDateData[factribAsOfDate]) ||
          (summary === SummaryType.RELATIVE &&
            fetchingRelAltDateData[factribAsOfDate])
        ) {
          loading = true;
        }
      } else {
        if (
          (summary === SummaryType.ABSOLUTE && fetchingAbsoluteData) ||
          (summary === SummaryType.RELATIVE && fetchingRelativeData)
        ) {
          loading = true;
        }
      }
      return {
        field: colId,
        headerName,
        colId,
        loading,
        X_onDelete: () => dispatch(deleteColumn(definition)),
      };
    });
  }, [
    definitions,
    dispatch,
    fetchingAbsAltDateData,
    fetchingAbsoluteData,
    fetchingRelAltDateData,
    fetchingRelativeData,
  ]);
};
